import { createAsyncThunk } from "@reduxjs/toolkit";
import { cmsRepository } from "modules/cms/api/cmsRepository";
import { CmsItem } from "modules/cms/types/cmsItem";

export const getSectionDataThunk = createAsyncThunk<CmsItem, string>(
  "section/getAllSections",
  async (type, { rejectWithValue }) => {
    return await cmsRepository.fetchByFilter(type).catch((error) => rejectWithValue({ error }));
  }
);
